module.exports = __webpack_public_path__ + "img/DocumentImport.68627f1e.svg";